<template>
    <p class="text-sm mb-4 last-of-type:mb-0">
        <slot></slot>
    </p>
</template>

<script lang="ts" setup></script>
